"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadPreferences = loadPreferences;
exports.savePreferences = savePreferences;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var cookieKeys = {
  klaro: 'klaro',
  segment: 'tracking-preferences'
};
var klaroDestinationIDs = [// these are the segment integration IDs corresponding to services previously flagged with Klaro.js
'Google Analytics', 'HubSpot', 'Hotjar', 'Visual Tagger', 'Google AdWords New']; // NOTE: top domains need a leading dot to be compatible with subdomains
// ref: https://stackoverflow.com/a/9618243/1204994

function getTopDomain() {
  var parts = window.location.hostname.split('.');
  if (parts.every(function (part) {
    return Number.isInteger(Number(part));
  })) return parts.join('.');
  var hostParts = parts.slice(-2);
  return "".concat(hostParts.length > 1 ? '.' : '').concat(hostParts.join('.'));
}

function mapSegment(_ref) {
  var destinationFlags = _ref.destinations,
      categoryFlags = _ref.categories;
  return {
    destinationFlags: destinationFlags,
    categoryFlags: categoryFlags
  };
}

function mapKlaro(_ref2, categories) {
  var bool = _ref2.analytics;
  var destinationFlags = {};
  klaroDestinationIDs.forEach(function (id) {
    return destinationFlags[id] = bool;
  });
  var categoryFlags = categories.reduce(function (flags, category) {
    flags[category.id] = category.destinationIDs.filter(function (id) {
      return klaroDestinationIDs.includes(id);
    }).every(function (id) {
      return destinationFlags[id];
    });
    return flags;
  }, {});
  return {
    destinationFlags: destinationFlags,
    categoryFlags: categoryFlags
  };
}

function loadPreferences(_ref3) {
  var categories = _ref3.categories;

  var _reporter = (0, _helpers.reporter)(),
      info = _reporter.info,
      table = _reporter.table;

  info('%cloadPreferences', 'color: cyan; font-weight: bold;');

  var segmentCookie = _jsCookie["default"].getJSON(cookieKeys.segment);

  var klaroCookie = _jsCookie["default"].getJSON(cookieKeys.klaro);

  if (!segmentCookie) {
    if (!klaroCookie) return {
      destinationFlags: {},
      categoryFlags: {}
    };
    var mapping = mapKlaro(klaroCookie, categories);
    table(mapping);
    savePreferences(mapping);
    return mapping;
  }

  if (!klaroCookie) return mapSegment(segmentCookie);

  var _mapKlaro = mapKlaro(klaroCookie, categories),
      klaroDestinationFlags = _mapKlaro.destinationFlags,
      klaroCategoryFlags = _mapKlaro.categoryFlags;

  var _mapSegment = mapSegment(segmentCookie),
      segmentDestinationFlags = _mapSegment.destinationFlags,
      segmentCategoryFlags = _mapSegment.categoryFlags;

  return {
    destinationFlags: _objectSpread(_objectSpread({}, klaroDestinationFlags), segmentDestinationFlags),
    categoryFlags: _objectSpread(_objectSpread({}, klaroCategoryFlags), segmentCategoryFlags)
  };
}

function savePreferences(_ref4) {
  var destinationFlags = _ref4.destinationFlags,
      categoryFlags = _ref4.categoryFlags;

  var _reporter2 = (0, _helpers.reporter)(),
      info = _reporter2.info,
      table = _reporter2.table;

  info('%csavePreferences', 'color: cyan; font-weight: bold;'); // table({ categoryFlags, destinationFlags });

  if (window.analytics) {
    // NB: this is still anonymous identification ¬‿¬
    window.analytics.identify(_defineProperty({}, cookieKeys.segment, {
      categories: categoryFlags,
      destinations: destinationFlags
    }));
  }

  info('%csetting cookie', 'color: orange; font-weight: bold;');
  var args = [cookieKeys.segment, {
    version: 1,
    destinations: destinationFlags,
    categories: categoryFlags
  }, {
    path: '/',
    expires: 365,
    domain: getTopDomain(),
    samesite: 'lax'
  }]; // args.forEach(table);

  _jsCookie["default"].set.apply(_jsCookie["default"], args); // emitter.emit('preferencesSaved', {
  //   destinationFlags,
  //   customPreferences,
  // });

}